import React, { useState, useRef, useEffect } from 'react';

function AnimaltHatterF() {
  const canvasRef = useRef(null);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    let animId;
    const resize = () => { canvas.width = canvas.offsetWidth; canvas.height = canvas.offsetHeight; };
    resize();
    window.addEventListener('resize', resize);

    const alakzatok = Array.from({length: 25}, () => ({
      x: Math.random() * canvas.width, y: Math.random() * canvas.height,
      meret: Math.random() * 60 + 20,
      vx: (Math.random() - 0.5) * 0.4, vy: (Math.random() - 0.5) * 0.4,
      szin: ['#1a73e8','#34a853','#9c27b0','#f9ab00','#00bcd4','#ea4335'][Math.floor(Math.random()*6)],
      alpha: Math.random() * 0.07 + 0.02,
      forgat: Math.random() * Math.PI * 2,
      forgSeb: (Math.random() - 0.5) * 0.01,
      tipus: Math.floor(Math.random() * 3),
    }));

    const rajzol = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      alakzatok.forEach(a => {
        a.x += a.vx; a.y += a.vy; a.forgat += a.forgSeb;
        if (a.x < -a.meret) a.x = canvas.width + a.meret;
        if (a.x > canvas.width + a.meret) a.x = -a.meret;
        if (a.y < -a.meret) a.y = canvas.height + a.meret;
        if (a.y > canvas.height + a.meret) a.y = -a.meret;
        ctx.save();
        ctx.globalAlpha = a.alpha;
        ctx.fillStyle = a.szin;
        if (a.tipus === 0) {
          ctx.beginPath(); ctx.arc(a.x, a.y, a.meret/2, 0, Math.PI*2); ctx.fill();
        } else if (a.tipus === 1) {
          ctx.translate(a.x, a.y); ctx.rotate(a.forgat);
          ctx.beginPath(); ctx.moveTo(0, -a.meret/2); ctx.lineTo(a.meret/2*0.866, a.meret/2*0.5); ctx.lineTo(-a.meret/2*0.866, a.meret/2*0.5); ctx.closePath(); ctx.fill();
        } else {
          ctx.translate(a.x, a.y); ctx.rotate(a.forgat);
          ctx.fillRect(-a.meret/4, -a.meret/4, a.meret/2, a.meret/2);
        }
        ctx.restore();
      });
      animId = requestAnimationFrame(rajzol);
    };
    rajzol();
    return () => { cancelAnimationFrame(animId); window.removeEventListener('resize', resize); };
  }, []);
  return <canvas ref={canvasRef} style={{position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', pointerEvents: 'none', zIndex: 0}}/>;
}

const globalStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700;800;900&family=Lora:ital,wght@0,400;0,500;0,600;0,700;1,400&display=swap');
  .fogalmak-wrapper * { font-family: 'Lora', serif !important; }
  .fogalmak-wrapper h1, .fogalmak-wrapper h2, .fogalmak-wrapper .f-cim-jatekos { font-family: 'Playfair Display', serif !important; }
  @keyframes felugrikF { 0% { transform: translateY(20px); opacity: 0; } 100% { transform: translateY(0); opacity: 1; } }
  .f-btn { transition: transform 0.2s cubic-bezier(0.34,1.56,0.64,1), box-shadow 0.2s ease !important; }
  .f-btn:hover { transform: translateY(-3px) scale(1.04) !important; }
  .f-kartya { transition: box-shadow 0.2s ease !important; }
  .f-kartya:hover { box-shadow: 0 8px 28px rgba(0,0,0,0.12) !important; }
`;

const korok = [
  { id: 'osszes', felirat: '🌐 Összes', szin: '#6b7280' },
  { id: '6-8', felirat: '🤖 6-8 év', szin: '#ff6b9d' },
  { id: '9-11', felirat: '🕵️ 9-11 év', szin: '#1976d2' },
  { id: '12-14', felirat: '🚀 12-14 év', szin: '#7c3aed' },
];

const kategoriak = [
  { id: 'osszes', felirat: '📚 Mind' },
  { id: 'fogalom', felirat: '📖 Fogalmak' },
  { id: 'utmutato', felirat: '🛠️ Útmutatók' },
  { id: 'netikett', felirat: '🤝 Netikett' },
  { id: 'biztonsag', felirat: '🔒 Biztonság' },
];

const tartalmak = [
  {
    id: 1, tipus: 'fogalom', kor: '6-8', cim: 'Mi az internet?', ikon: '🌐', szin: '#4d96ff',
    rovid: 'Az internet egy hatalmas hálózat, ami összeköti a számítógépeket a világ minden tájáról.',
    teljes: 'Az internet olyan, mint egy nagy pókháló, ami az egész világot összeköti. Segítségével videókat nézhetünk, zenét hallgathatunk, játszhatunk és üzeneteket küldhetünk bárkinek.\n\nAz interneten sok szép és hasznos dolog van - de vannak dolgok, amikre figyelni kell. Ha valami furcsa vagy ijesztő történik - mindig szólj egy felnőttnek!',
    cimkek: ['alapfogalom', 'internet'], lepesek: null,
  },
  {
    id: 2, tipus: 'fogalom', kor: '6-8', cim: 'Mi az a jelszó?', ikon: '🔑', szin: '#c77dff',
    rovid: 'A jelszó olyan, mint egy titkos kulcs, ami megvédi a fiókodat. Csak te tudhatod!',
    teljes: 'A jelszó egy titkos szó vagy számsorrend, amit csak te tudsz.\n\n✅ A jelszót soha ne mondd el senkinek!\n✅ Ha valaki kéri a jelszavadat az interneten - szólj azonnal a szüleidnek!\n✅ A jelszót a szüleid segítségével hozd létre.',
    cimkek: ['jelszó', 'biztonság'], lepesek: null,
  },
  {
    id: 3, tipus: 'fogalom', kor: '6-8', cim: 'Mi az a személyes adat?', ikon: '🤫', szin: '#ff6b35',
    rovid: 'Személyes adat minden, ami rólad szól: a neved, lakcímed, telefonszámod. Ezeket védd!',
    teljes: 'A személyes adataid csak rólad szólnak, és titkosnak kell maradniuk az interneten.\n\n🔒 TITOK marad:\n• A neved és lakcímed\n• A telefonszámod\n• Az iskolád neve\n• A jelszavaid\n\n✅ MEGOSZTHATÓ:\n• A kedvenc színed\n• A kedvenc zenéd\n\nHa valaki személyes adatot kér - szólj a szüleidnek!',
    cimkek: ['személyes adat', 'titok', 'biztonság'], lepesek: null,
  },
  {
    id: 4, tipus: 'fogalom', kor: '9-11', cim: 'Adathalászat (Phishing)', ikon: '🎣', szin: '#1565c0',
    rovid: 'Olyan átverés, ahol valaki úgy tesz, mintha megbízható személy lenne - hogy ellopja az adataidat.',
    teljes: 'A phishing az egyik leggyakoribb internetes átverés.\n\n🚨 Figyelmeztető jelek:\n• Sürgető hangnem ("Azonnal!", "24 óra!")\n• Hamis email cím\n• "Nyertél valamit!" típusú üzenetek\n• Jelszót vagy személyes adatot kér\n\n✅ Mit tegyél:\nSoha ne kattints gyanús linkekre! Kérdezz meg egy felnőttet.',
    cimkek: ['phishing', 'átverés', 'biztonság'], lepesek: null,
  },
  {
    id: 5, tipus: 'fogalom', kor: '9-11', cim: 'Digitális lábnyom', ikon: '👣', szin: '#0d47a1',
    rovid: 'Minden, amit az interneten csinálsz, nyomot hagy - és ez sokáig megmaradhat.',
    teljes: 'A digitális lábnyom mindaz, amit az interneten csinálsz.\n\n📊 Kétféle van:\n\n🟦 AKTÍV - Te hozod létre:\n• Posztok, kommentek, fotók\n• Feliratkozások, regisztrációk\n\n🟨 PASSZÍV - Mások gyűjtik:\n• Keresési előzmények\n• Helyadatok (GPS)\n\n⚠️ Az internet nem felejt!\n\n💡 Aranyszabály: "Megmutatnám ezt a tanárnak? 10 év múlva is vállalnám?"',
    cimkek: ['digitális lábnyom', 'adatvédelem'], lepesek: null,
  },
  {
    id: 6, tipus: 'fogalom', kor: '9-11', cim: 'Kétlépéses azonosítás (2FA)', ikon: '📱', szin: '#1976d2',
    rovid: 'Extra biztonsági réteg: jelszó + SMS kód. Még ha valaki tudja is a jelszavadat, nem tud belépni.',
    teljes: 'A 2FA olyan, mint egy dupla zár az ajtón.\n\n🔐 Hogyan működik?\n1. Beírod a jelszavadat\n2. Kapsz egy SMS kódot\n3. Csak mindkettővel léphetsz be\n\n✅ Miért fontos?\nHa valaki megszerzi a jelszavadat, de nincs meg a 2FA-kódja, akkor sem tud belépni!\n\n📱 Hol kapcsold be:\n• Google fiók\n• Instagram, TikTok\n• Gaming fiókok',
    cimkek: ['2FA', 'jelszó', 'biztonság'], lepesek: null,
  },
  {
    id: 7, tipus: 'fogalom', kor: '12-14', cim: 'Deepfake', ikon: '🎭', szin: '#7c3aed',
    rovid: 'AI által generált hamis videó vagy hang - egy valódi személyt ábrázol úgy, hogy olyat "mond", amit valójában soha nem mondott.',
    teljes: 'A deepfake mesterséges intelligencia segítségével készített hamis videó.\n\n⚠️ Miért veszélyes?\n• Híres emberek (pl. youtuberek, énekesek) "mondanak" ki nem mondott dolgokat\n• Hangklónozással csalásokat követnek el\n• Zaklatáshoz is felhasználható\n\n🔍 Hogyan ismered fel?\n• A száj mozgása nem egyezik a hanggal\n• Szemvillogás ritka vagy természetellenes\n• Kezek, ujjak furcsán néznek ki\n\nAranyszabály: Ellenőrizz, mielőtt megosztasz!',
    cimkek: ['deepfake', 'AI', 'dezinformáció'], lepesek: null,
  },
  {
    id: 8, tipus: 'fogalom', kor: '12-14', cim: 'Filterbuborék (Echo chamber)', ikon: '🫧', szin: '#06b6d4',
    rovid: 'Az algoritmus csak olyan tartalmakat mutat, amik megerősítik a meglévő véleményedet.',
    teljes: 'A filterbuborék olyan, mint egy légbuborék: csak azt látod, amit az algoritmus mutat.\n\n🔄 Hogyan alakul ki?\n1. Lájkolsz egy típusú tartalmat\n2. Az algoritmus többet mutat belőle\n3. Csak egyféle nézőpontot látsz\n\n⚠️ Miért probléma?\n• Szélsőségesebb nézeteket alakít ki\n• Megkönnyíti a dezinformáció terjedését\n\n✅ Hogyan kerüld el?\n• Keress más nézőpontú tartalmakat\n• Több különböző forrást használj',
    cimkek: ['algoritmus', 'filterbuborék', 'közösségi média'], lepesek: null,
  },
  {
    id: 9, tipus: 'fogalom', kor: '12-14', cim: 'GDPR - Adatvédelmi jogok', ikon: '⚖️', szin: '#10b981',
    rovid: 'Az EU rendelete, ami megvédi a személyes adataidat, és jogokat ad neked azok felett.',
    teljes: 'A GDPR az Európai Unió 2018 óta érvényben lévő adatvédelmi rendelete, ami szabályozza, hogyan kezelhetik a cégek az adataidat.\n\n⚖️ Az 5 legfontosabb jogod:\n\n1️⃣ HOZZÁFÉRÉSI JOG - "Mit tudtok rólam?"\n2️⃣ TÖRLÉSI JOG - "Felejts el!"\n3️⃣ HELYESBÍTÉSI JOG - "Javítsd ki!"\n4️⃣ KORLÁTOZÁSI JOG - "Ne használd!"\n5️⃣ ADATHORDOZHATÓSÁG - "Add át máshova!"\n\n📧 Hogyan érvényesíted?\nKüldj emailt a cég adatvédelmi tisztviselőjének. Ha nem válaszolnak: NAIH panasz.',
    cimkek: ['GDPR', 'adatvédelem', 'jogok'], lepesek: null,
  },
  {
    id: 10, tipus: 'fogalom', kor: '9-11', cim: 'Cyberbullying', ikon: '🛡️', szin: '#ec4899',
    rovid: 'Online zaklatás: szándékos, ismételt bántás az interneten. Ugyanolyan komolyan kell venni, mint a személyes zaklatást.',
    teljes: 'A cyberbullying szándékos, ismételt bántás az interneten.\n\n📋 Formái:\n• Bántó üzenetek, kommentek\n• Kínos fotók terjesztése\n• Online csoportból való kizárás\n• Fenyegetések\n\n✅ Ha téged érint:\n1. NE válaszolj vissza\n2. Csinálj SCREENSHOTOT\n3. BLOKKOLD a zaklatót\n4. JELENTS BE a platformon\n5. SZÓLJ egy felnőttnek',
    cimkek: ['cyberbullying', 'zaklatás', 'biztonság'], lepesek: null,
  },
  {
    id: 11, tipus: 'utmutato', kor: '9-11', cim: '🔐 Hogyan készíts erős jelszót?', ikon: '🔐', szin: '#1976d2',
    rovid: 'Lépésről lépésre útmutató a tökéletes jelszó létrehozásához.',
    teljes: null,
    cimkek: ['jelszó', 'biztonság', 'útmutató'],
    lepesek: [
      { szam: 1, cim: 'Legyen legalább 12 karakter!', leiras: 'Minél hosszabb a jelszó, annál nehezebb feltörni. A "kutya" jelszót 2 másodperc alatt feltörik.', pelda: '❌ kutya\n✅ Kutya#2024!Boldog', ikon: '📏' },
      { szam: 2, cim: 'Használj nagy és kisbetűt!', leiras: 'A vegyes betűk sokkal nehezebben feltörhetők.', pelda: '❌ kutya2024\n✅ KuTyA2024', ikon: '🔤' },
      { szam: 3, cim: 'Tegyél bele számokat!', leiras: 'A számok növelik a lehetséges kombinációk számát.', pelda: '❌ kutya\n✅ k3utya20!24', ikon: '🔢' },
      { szam: 4, cim: 'Adj hozzá speciális karaktereket!', leiras: 'A ! @ # $ % karakterek megnehezítik a feltörést.', pelda: '❌ Kutya2024\n✅ K@utya#2024!', ikon: '✨' },
      { szam: 5, cim: 'Ne használd a neved!', leiras: 'Az első, amit egy hacker kipróbál: a neved, születésnapod. Ezeket kerüld!', pelda: '❌ Anna2010\n✅ Alma#Golf!2024', ikon: '🚫' },
      { szam: 6, cim: 'Minden fiókhoz különböző jelszó!', leiras: 'Ha ugyanazt használod mindenhol, és feltörik, az összeset feltörik! Használj jelszókezelőt (pl. Bitwarden - ingyenes).', pelda: '❌ mindenhol: Kutya2024!\n✅ minden fióknak egyedi jelszó', ikon: '🗂️' },
      { szam: 7, cim: 'Kapcsold be a 2FA-t!', leiras: 'A kétlépéses azonosítás extra védelmet ad.', pelda: '📱 SMS kód vagy authenticator app\n✅ Google, Instagram, Roblox mind tudja', ikon: '📱' },
    ],
  },
  {
    id: 12, tipus: 'utmutato', kor: '9-11', cim: '🔍 Hogyan ellenőrizz egy hírt?', ikon: '🔍', szin: '#1565c0',
    rovid: 'A SIFT módszer - 4 lépés mielőtt megosztasz bármit.',
    teljes: null,
    cimkek: ['tényellenőrzés', 'álhír', 'SIFT'],
    lepesek: [
      { szam: 1, cim: '🛑 STOP - Állj meg!', leiras: 'Mielőtt megosztasz valamit - ÁLLJ MEG! Az azonnali reakció pontosan amit a dezinformáció terjesztői akarnak.', pelda: 'Erős érzelem = figyelmeztető jel!\nMost kell a legjobban ellenőrizni.', ikon: '🛑' },
      { szam: 2, cim: '🔎 INVESTIGATE - Vizsgáld a forrást!', leiras: 'Ki írta? Mikor? Milyen oldalon? Nyiss új fület, és keresd meg, ki az az oldal.', pelda: 'Lateral reading:\n→ Ne olvasd végig az ismeretlen oldalt\n→ Keress más oldalakon, hogy ki az', ikon: '🔎' },
      { szam: 3, cim: '📍 FIND - Keress más forrásban!', leiras: 'Ha egy hír csak egy helyen jelent meg - gyanús!', pelda: 'Magyar tényellenőrzők:\n• Lakmusz.hu\n• Ténykérdés', ikon: '📍' },
      { szam: 4, cim: '📄 TRACE - Kövesd vissza!', leiras: 'Keresd meg, hol jelent meg először.', pelda: 'Eszközök:\n• Google Reverse Image Search\n• TinEye.com', ikon: '📄' },
      { szam: 5, cim: '✅ DÖNTÉS - Megoszted?', leiras: 'Ha minden ellenőrzés megvan, és megbízható: megoszd. Ha bizonytalan: inkább ne!', pelda: '✅ Legalább 2 forrás megerősíti\n❌ Ha csak 1 ismeretlen oldalon jelent meg', ikon: '✅' },
    ],
  },
  {
    id: 13, tipus: 'utmutato', kor: '12-14', cim: '🛡️ Adatvédelmi beállítások checklist', ikon: '🛡️', szin: '#7c3aed',
    rovid: 'Lépésről lépésre ellenőrizd a közösségi média adatvédelmi beállításaidat.',
    teljes: null,
    cimkek: ['adatvédelem', 'beállítások', 'checklist'],
    lepesek: [
      { szam: 1, cim: 'Profil láthatóság', leiras: 'Ellenőrizd: ki láthatja a profilodat?', pelda: '✅ Csak követők láthatják\n❌ Mindenki láthatja', ikon: '👁️' },
      { szam: 2, cim: 'Helymeghatározás', leiras: 'Kapcsold ki a folyamatos helymeghatározást!', pelda: 'iOS: Beállítások → Adatvédelem → Helyszín\nAndroid: Beállítások → Helyszín → Engedélyek', ikon: '📍' },
      { szam: 3, cim: 'Alkalmazásengedélyek', leiras: 'Nézd át, melyik app milyen engedélyeket kapott.', pelda: '✅ Kamera app → kamera: LOGIKUS\n❌ Játék → kontaktlista: NEM', ikon: '🔐' },
      { szam: 4, cim: 'Régi posztok', leiras: 'Görgess vissza. Van-e olyan, amit ma már nem osztanál meg?', pelda: 'Kérdezd meg: "Megmutatnám egy munkáltatónak?"\nHa nem: privátra állítod vagy törlöd', ikon: '📜' },
      { szam: 5, cim: 'Cookie beállítások', leiras: 'Csak a szükséges cookie-kat fogadd el!', pelda: '✅ Szükséges cookie-k: OK\n❌ Marketing cookie-k: NEM kell', ikon: '🍪' },
      { szam: 6, cim: 'Jelszó + 2FA', leiras: 'Minden fontos fióknál van-e erős jelszó és 2FA?', pelda: '✅ Minden fiókhoz egyedi jelszó\n✅ 2FA bekapcsolva', ikon: '🔑' },
    ],
  },
  {
    id: 14, tipus: 'utmutato', kor: '6-8', cim: '🆘 Mit tegyél ha megijedsz?', ikon: '🆘', szin: '#ff6b35',
    rovid: 'Lépésről lépésre mit csinálj ha valami ijesztő történik az interneten.',
    teljes: null,
    cimkek: ['segítség', 'veszély', 'útmutató'],
    lepesek: [
      { szam: 1, cim: 'Tedd le a tabletet!', leiras: 'Ha valami ijesztőt látsz - azonnal tedd le az eszközt.', pelda: '📱 Tedd le a tabletet\n😮‍💨 Vegyél egy mély levegőt', ikon: '🛑' },
      { szam: 2, cim: 'Szólj egy felnőttnek!', leiras: 'Szaladj oda anyukádhoz, apukádhoz vagy más megbízható felnőtthöz.', pelda: '👨‍👩‍👧 Szülő\n👴👵 Nagyszülő\n👩‍🏫 Tanár', ikon: '🏃' },
      { szam: 3, cim: 'Meséld el mi történt!', leiras: 'Ne félj elmondani! A felnőtt segíteni fog.', pelda: 'Mondd el:\n• Mit láttál\n• Mikor történt\n• Mi volt furcsa', ikon: '💬' },
      { szam: 4, cim: 'A felnőtt megoldja!', leiras: 'Ez az ő feladata - nem neked kell megoldanod!', pelda: '✅ Törli az üzenetet\n✅ Blokkolja az ismeretlent', ikon: '🤗' },
    ],
  },
  {
    id: 15, tipus: 'utmutato', kor: '9-11', cim: '🚨 Mit tegyél ha zaklatnak?', ikon: '🚨', szin: '#ec4899',
    rovid: 'Lépésről lépésre protokoll online zaklatás esetén.',
    teljes: null,
    cimkek: ['cyberbullying', 'zaklatás', 'protokoll'],
    lepesek: [
      { szam: 1, cim: 'Ne válaszolj vissza!', leiras: 'A zaklatók reakciót akarnak. A hallgatás stratégia, nem gyengeség!', pelda: '❌ "Te is egy idióta vagy!"\n✅ Semmi - nem válaszolsz', ikon: '🤐' },
      { szam: 2, cim: 'Csinálj screenshotot!', leiras: 'Mielőtt bármit tennél: mentsd el a bizonyítékot!', pelda: '📸 iPhone: Oldal gomb + Hangerő fel\n📸 Android: Hangerő le + Bekapcs gomb', ikon: '📸' },
      { szam: 3, cim: 'Blokkold!', leiras: 'Minden platformon blokkold a zaklatót.', pelda: '🔴 Instagram: Profil → Blokkolás\n🔴 TikTok: Profil → Blokkolás', ikon: '🚫' },
      { szam: 4, cim: 'Jelents be!', leiras: 'A bejelentés valóban segít.', pelda: '⚑ Instagram: Poszt → Jelentés\n⚑ TikTok: Videó → Bejelentés', ikon: '🚩' },
      { szam: 5, cim: 'Szólj felnőttnek!', leiras: 'Ne maradj egyedül! A screenshotokkal menj egy szülőhöz vagy tanárhoz.', pelda: '👨‍👩‍👧 Szülő\n👩‍🏫 Osztályfőnök\n📞 Áldozatsegítő: 06-80-225-225', ikon: '👥' },
    ],
  },
  {
    id: 16, tipus: 'netikett', kor: '6-8', cim: '😊 Az internet szabályai', ikon: '😊', szin: '#6bcb77',
    rovid: 'Úgy viselkedj online, ahogy szeretnéd, hogy veled is viselkedjenek!',
    teljes: 'Az interneten is emberekkel kommunikálsz!\n\n✅ Az internet arany szabályai:\n\n🌟 Légy kedves!\nCsak olyat írj, amit a valóságban is megmondanál\n\n🌟 Gondolkodj mielőtt írsz!\nAmit egyszer elküldtél, nem veheted vissza\n\n🌟 Mások képét ne terjeszd!\nValaki fotóját csak az engedélyével szabad megosztani\n\n🌟 Ne írj csupa NAGYBETŰVEL!\nAz interneten a nagybetű kiabálást jelent\n\n🌟 Ha valami bántott - szólj!\nNem kell egyedül tartanod magadban - egy felnőtt mindig segít!',
    cimkek: ['netikett', 'szabályok', 'viselkedés'], lepesek: null,
  },
  {
    id: 17, tipus: 'netikett', kor: '9-11', cim: '💬 Online kommunikáció', ikon: '💬', szin: '#1976d2',
    rovid: 'Hogyan kommunikálj tiszteletteljesen az interneten.',
    teljes: 'A netikett az internetes viselkedés szabályrendszere.\n\n📝 Üzenetek és chat:\n✅ Köszönj és mutatkozz be ismeretlen csoportban\n✅ Rövid érthető üzenetek\n✅ Emojit mértékkel\n❌ Ne spammelj\n\n📸 Képek és videók:\n✅ Mások képét csak engedéllyel oszthatod meg\n❌ Kínos fotókat sose ossz meg\n\n💬 Kommentek:\n✅ Kritika rendben, sértés nem\n❌ Ne trollkodj senkivel se!\n\n🎮 Gaming chat:\n✅ GG (good game) legyen szokás\n❌ Rasszizmus, szexizmus - ilyet soha ne írj, és ha látod, jelentsd be!',
    cimkek: ['netikett', 'kommunikáció', 'illemszabályok'], lepesek: null,
  },
  {
    id: 18, tipus: 'netikett', kor: '12-14', cim: '🌍 Digitális állampolgárság', ikon: '🌍', szin: '#7c3aed',
    rovid: 'A felelős online viselkedés elvei.',
    teljes: 'A digitális állampolgárság azt jelenti, hogy felelősen veszünk részt az online közösségekben.\n\n1️⃣ DIGITÁLIS KOMMUNIKÁCIÓ\nFelelős, tiszteletteli kommunikáció minden platformon\n\n2️⃣ DIGITÁLIS TUDATOSSÁG\nAz online világ értése és kritikus szemlélete\n\n3️⃣ DIGITÁLIS ETIKA\nHelyes viselkedés online - akkor is, ha senki nem látja\n\n4️⃣ DIGITÁLIS TÖRVÉNY\nAz online tér is jogszabályok alá esik\n\n5️⃣ DIGITÁLIS BIZTONSÁG\nSaját magad és mások védelme online',
    cimkek: ['digitális állampolgárság', 'netikett', 'felelősség'], lepesek: null,
  },
  {
    id: 19, tipus: 'netikett', kor: '9-11', cim: '🎮 Gaming netikett', ikon: '🎮', szin: '#10b981',
    rovid: 'Hogyan viselkedj a gaming közösségekben.',
    teljes: 'A gaming közösségek saját kultúrával rendelkeznek.\n\n🎮 Gaming illemszabályok:\n\n✅ GG (Good Game) - mindig mondd a meccs végén\n✅ Ha hibázol: "my bad"\n✅ Segíts az újoncoknak\n\n❌ BM (Bad Manners) - soha\n❌ Rasszizmus, szexizmus - ha ezt látod, azonnal jelentsd be!\n\n🔒 Gaming biztonság:\n• Soha ne add meg a jelszavadat\n• Ingyenes V-bucks/Robux = átverés\n• Személyes adatok a chaten = nem',
    cimkek: ['gaming', 'netikett', 'közösség'], lepesek: null,
  },
  {
    id: 20, tipus: 'biztonsag', kor: '9-11', cim: '🔒 Fiókbiztonság alapok', ikon: '🔒', szin: '#1976d2',
    rovid: 'Az alapvető lépések, hogy a fiókodat biztonságban tartsd.',
    teljes: '🔒 A biztonságos fiók 5 alappillére:\n\n1️⃣ ERŐS EGYEDI JELSZÓ\nMinden fiókhoz más jelszó, legalább 12 karakter.\n\n2️⃣ KÉTLÉPÉSES AZONOSÍTÁS (2FA)\nKapcsolj be SMS kódot minden fontos fióknál.\n\n3️⃣ GYANÚS LINKEK ELKERÜLÉSE\nSoha ne kattints ismeretlen linkre emailben!\n\n4️⃣ RENDSZERES ELLENŐRZÉS\nNézd meg, hol vagy belépve.\n\n5️⃣ JELSZÓKEZELŐ\nBitwarden (ingyenes) ajánlott.\n\n🚨 Ha feltörték:\n1. Szólj egy felnőttnek\n2. Változtass jelszót\n3. Kapcsold be a 2FA-t',
    cimkek: ['fiókbiztonság', 'jelszó', '2FA'], lepesek: null,
  },
  {
    id: 21, tipus: 'biztonsag', kor: '12-14', cim: '📱 Alkalmazásengedélyek', ikon: '📱', szin: '#f59e0b',
    rovid: 'Az appok sokszor többet kérnek, mint ami szükséges - így döntsd el, melyiket add meg.',
    teljes: 'Az alkalmazásengedélyek aranyszabálya:\nKérdezd meg: "Van-e LOGIKUS indoka?"\n\n✅ LOGIKUS:\n• Kamera app → kamera\n• Térkép app → helymeghatározás\n\n❌ NEM LOGIKUS:\n• Zseblámpa app → mikrofon\n• Játék app → kontaktlista\n\n🔐 Hogyan ellenőrizd:\n\niOS:\nBeállítások → Adatvédelem → kategória → app\n\nAndroid:\nBeállítások → Alkalmazások → app → Engedélyek',
    cimkek: ['app', 'engedélyek', 'adatvédelem'], lepesek: null,
  },
  {
    id: 22, tipus: 'biztonsag', kor: '12-14', cim: '🌐 Nyilvános WiFi veszélyei', ikon: '🌐', szin: '#ec4899',
    rovid: 'A nyilvános WiFi kényelmes, de komoly biztonsági kockázatokat rejt.',
    teljes: '📡 Nyilvános WiFi - amit tudnod kell:\n\n⚠️ Kockázatok:\n• Man-in-the-Middle támadás: valaki lehallgatja a forgalmadat\n• Fake WiFi: egy hacker saját hálózatot hoz létre\n\n✅ Oké nyilvános WiFi-n:\n• Egyszerű böngészés\n• YouTube, streaming\n\n❌ SOHA nyilvános WiFi-n:\n• Banki tranzakciók\n• Jelszó megadása fontos fiókba\n\n🛡️ Ha mégis szükséges: VPN\nAjánlott ingyenes: ProtonVPN',
    cimkek: ['WiFi', 'biztonság', 'VPN'], lepesek: null,
  },
];

// ============ LÉPÉSES ÚTMUTATÓ ============
function LepesesUtmutato({ tartalom }) {
  const [aktLepés, setAktLepés] = useState(0);
  const [teljesitett, setTeljesitett] = useState([]);

  const kovetkezo = () => {
    if (!teljesitett.includes(aktLepés)) setTeljesitett(p => [...p, aktLepés]);
    if (aktLepés < tartalom.lepesek.length - 1) setAktLepés(p => p + 1);
  };
  const vissza = () => { if (aktLepés > 0) setAktLepés(p => p - 1); };
  const mindenKesz = teljesitett.length === tartalom.lepesek.length;
  const l = tartalom.lepesek[aktLepés];

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '1.25rem'}}>
      <div style={{display: 'flex', gap: '6px', alignItems: 'center', flexWrap: 'wrap'}}>
        {tartalom.lepesek.map((_, i) => (
          <div key={i} onClick={() => setAktLepés(i)}
            style={{width: i === aktLepés ? '32px' : '14px', height: '14px', borderRadius: '7px', background: teljesitett.includes(i) ? '#34a853' : i === aktLepés ? tartalom.szin : '#e0e0e0', cursor: 'pointer', transition: 'all 0.3s', flexShrink: 0}}/>
        ))}
        <span style={{fontSize: '13px', color: 'var(--text-muted)', fontWeight: '700', marginLeft: '8px'}}>{aktLepés + 1}/{tartalom.lepesek.length}</span>
      </div>
      <div style={{background: tartalom.szin + '10', border: '2px solid ' + tartalom.szin, borderRadius: '20px', padding: '1.5rem', animation: 'felugrikF 0.3s ease-out'}}>
        <div style={{display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '1rem'}}>
          <div style={{width: '50px', height: '50px', borderRadius: '15px', background: 'linear-gradient(135deg,' + tartalom.szin + ',' + tartalom.szin + 'cc)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '24px', flexShrink: 0}}>
            {l.ikon}
          </div>
          <div>
            <div style={{fontSize: '11px', color: tartalom.szin, fontWeight: '800', textTransform: 'uppercase', letterSpacing: '1px'}}>{l.szam}. lépés</div>
            <div style={{fontSize: '17px', fontWeight: '900', color: 'var(--text-primary)'}}>{l.cim}</div>
          </div>
        </div>
        <p style={{fontSize: '15px', color: 'var(--text-secondary)', lineHeight: '1.8', fontWeight: '600', margin: '0 0 1rem'}}>{l.leiras}</p>
        {l.pelda && (
          <div style={{background: 'rgba(0,0,0,0.04)', borderRadius: '12px', padding: '0.875rem 1.125rem', border: '1px solid ' + tartalom.szin + '20'}}>
            <pre style={{fontSize: '14px', color: '#555', fontFamily: 'Lora, serif', margin: 0, whiteSpace: 'pre-wrap', lineHeight: 1.7, fontWeight: '700'}}>{l.pelda}</pre>
          </div>
        )}
      </div>
      {mindenKesz && (
        <div style={{background: '#e8f5e9', border: '2px solid #34a853', borderRadius: '16px', padding: '1rem', textAlign: 'center'}}>
          <p style={{fontSize: '17px', fontWeight: '900', color: '#1e7e34', margin: 0}}>🎉 Minden lépést teljesítettél!</p>
        </div>
      )}
      <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
        <button onClick={vissza} disabled={aktLepés === 0} className="f-btn"
          style={{background: 'transparent', border: '2px solid ' + (aktLepés === 0 ? '#e0e0e0' : tartalom.szin), borderRadius: '50px', padding: '9px 20px', cursor: aktLepés === 0 ? 'not-allowed' : 'pointer', fontSize: '14px', fontWeight: '800', color: aktLepés === 0 ? '#ccc' : tartalom.szin}}>
          ← Előző
        </button>
        {aktLepés < tartalom.lepesek.length - 1 ? (
          <button onClick={kovetkezo} className="f-btn"
            style={{background: 'linear-gradient(135deg,' + tartalom.szin + ',' + tartalom.szin + 'cc)', border: 'none', borderRadius: '50px', padding: '9px 22px', cursor: 'pointer', fontSize: '14px', fontWeight: '800', color: 'white', boxShadow: '0 4px 14px ' + tartalom.szin + '40'}}>
            Következő →
          </button>
        ) : (
          <button onClick={() => { if (!teljesitett.includes(aktLepés)) setTeljesitett(p => [...p, aktLepés]); }} className="f-btn"
            style={{background: 'linear-gradient(135deg,#34a853,#66bb6a)', border: 'none', borderRadius: '50px', padding: '9px 22px', cursor: 'pointer', fontSize: '14px', fontWeight: '800', color: 'white'}}>
            ✅ Kész!
          </button>
        )}
      </div>
    </div>
  );
}

// ============ FŐ KOMPONENS ============
function Fogalmak() {
  const [aktivKor, setAktivKor] = useState('osszes');
  const [aktivKategoria, setAktivKategoria] = useState('osszes');
  const [kereses, setKereses] = useState('');
  const [nyitottId, setNyitottId] = useState(null);

  const szurt = tartalmak.filter(t => {
    const korOk = aktivKor === 'osszes' || t.kor === aktivKor;
    const katOk = aktivKategoria === 'osszes' || t.tipus === aktivKategoria;
    const kerOk = kereses === '' ||
      t.cim.toLowerCase().includes(kereses.toLowerCase()) ||
      t.rovid.toLowerCase().includes(kereses.toLowerCase()) ||
      t.cimkek.some(c => c.toLowerCase().includes(kereses.toLowerCase()));
    return korOk && katOk && kerOk;
  });

  return (
    <div className="fogalmak-wrapper" style={{minHeight: 'calc(100vh - 70px)', background: 'var(--bg-page)', padding: '3rem 2rem', position: 'relative', overflow: 'hidden'}}>
      <style>{globalStyles}</style>
      <AnimaltHatterF/>
      <div style={{position: 'relative', zIndex: 1}}>

        <div style={{textAlign: 'center', marginBottom: '3rem', animation: 'felugrikF 0.5s ease-out'}}>
          <div style={{display: 'inline-flex', alignItems: 'center', gap: '10px', background: 'rgba(255,255,255,0.9)', border: '2px solid #7c3aed', borderRadius: '50px', padding: '10px 24px', fontSize: '15px', fontWeight: '800', color: '#7c3aed', marginBottom: '1.25rem', boxShadow: '0 4px 16px rgba(124,58,237,0.12)'}}>
            <span style={{fontSize: '22px'}}>📚</span> Fogalmak és hasznos tudnivalók
          </div>
          <h1 style={{fontSize: '42px', fontWeight: '900', color: 'var(--text-primary)', marginBottom: '0.75rem'}}>
            Digitális <span style={{background: 'linear-gradient(135deg, #1a73e8, #9c27b0)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text'}}>szótár</span>
          </h1>
          <p style={{fontSize: '17px', color: 'var(--text-secondary)', maxWidth: '500px', margin: '0 auto', fontWeight: '600', lineHeight: 1.7}}>
            Fogalmak, útmutatók, netikett és biztonsági tippek - minden korosztálynak! 🌐
          </p>
        </div>

        <div style={{maxWidth: '560px', margin: '0 auto 2.5rem', position: 'relative'}}>
          <span style={{position: 'absolute', left: '18px', top: '50%', transform: 'translateY(-50%)', fontSize: '20px', pointerEvents: 'none'}}>🔍</span>
          <input
            type="text"
            placeholder="Keresés fogalmak között..."
            value={kereses}
            onChange={e => setKereses(e.target.value)}
            style={{width: '100%', padding: '16px 50px 16px 52px', borderRadius: '50px', border: '2px solid var(--border-color-strong)', fontSize: '16px', fontWeight: '700', fontFamily: 'Lora, serif', outline: 'none', boxSizing: 'border-box', background: 'var(--bg-input)', color: 'var(--text-primary)', boxShadow: '0 4px 20px var(--shadow-color)'}}
          />
          {kereses && (
            <button onClick={() => setKereses('')} style={{position: 'absolute', right: '18px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', fontSize: '18px', cursor: 'pointer', color: 'var(--text-muted)'}}>✕</button>
          )}
        </div>

        <div style={{display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap', marginBottom: '1.25rem'}}>
          {korok.map(k => (
            <button key={k.id} onClick={() => setAktivKor(k.id)} className="f-btn"
              style={{padding: '10px 22px', borderRadius: '50px', border: '2px solid ' + (aktivKor === k.id ? k.szin : 'var(--border-color-strong)'), background: aktivKor === k.id ? k.szin + '15' : 'var(--bg-card-transparent)', color: aktivKor === k.id ? k.szin : 'var(--text-muted)', fontSize: '14px', fontWeight: '800', cursor: 'pointer', boxShadow: aktivKor === k.id ? '0 4px 14px ' + k.szin + '25' : 'none'}}>
              {k.felirat}
            </button>
          ))}
        </div>

        <div style={{display: 'flex', gap: '8px', justifyContent: 'center', flexWrap: 'wrap', marginBottom: '2.5rem'}}>
          {kategoriak.map(k => (
            <button key={k.id} onClick={() => setAktivKategoria(k.id)} className="f-btn"
              style={{padding: '8px 18px', borderRadius: '50px', border: '2px solid ' + (aktivKategoria === k.id ? '#7c3aed' : 'var(--border-color-strong)'), background: aktivKategoria === k.id ? 'rgba(124,58,237,0.1)' : 'var(--bg-card-transparent)', color: aktivKategoria === k.id ? '#7c3aed' : 'var(--text-muted)', fontSize: '13px', fontWeight: '800', cursor: 'pointer'}}>
              {k.felirat}
            </button>
          ))}
        </div>

        <div style={{textAlign: 'center', marginBottom: '1.5rem'}}>
          <span style={{fontSize: '14px', color: 'var(--text-muted)', fontWeight: '700'}}>{szurt.length} találat</span>
        </div>

        <div style={{maxWidth: '800px', margin: '0 auto', display: 'flex', flexDirection: 'column', gap: '0.875rem'}}>
          {szurt.map(t => {
            const nyitva = nyitottId === t.id;
            const korSzin = korok.find(k => k.id === t.kor)?.szin || '#888';
            const korFelirat = korok.find(k => k.id === t.kor)?.felirat || '';
            const katFelirat = kategoriak.find(k => k.id === t.tipus)?.felirat || '';
            return (
              <div key={t.id} className="f-kartya"
                style={{background: 'var(--bg-card-transparent)', backdropFilter: 'blur(10px)', borderRadius: '22px', border: '2px solid ' + (nyitva ? t.szin : 'var(--border-color)'), boxShadow: nyitva ? '0 12px 40px ' + t.szin + '20' : '0 4px 20px var(--shadow-color)', overflow: 'hidden', transition: 'all 0.3s'}}>

                <div onClick={() => setNyitottId(nyitva ? null : t.id)}
                  style={{padding: '1.25rem 1.5rem', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '14px'}}>
                  <div style={{width: '50px', height: '50px', borderRadius: '15px', background: t.szin + '18', border: '1.5px solid ' + t.szin + '35', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '24px', flexShrink: 0}}>
                    {t.ikon}
                  </div>
                  <div style={{flex: 1, minWidth: 0}}>
                    <div style={{display: 'flex', gap: '6px', marginBottom: '4px', flexWrap: 'wrap'}}>
                      <span style={{fontSize: '11px', background: korSzin + '15', color: korSzin, borderRadius: '6px', padding: '2px 7px', fontWeight: '800'}}>{korFelirat}</span>
                      <span style={{fontSize: '11px', background: 'var(--bg-card-alt)', color: 'var(--text-muted)', borderRadius: '6px', padding: '2px 7px', fontWeight: '800'}}>{katFelirat}</span>
                    </div>
                    <h3 style={{fontSize: '16px', fontWeight: '900', color: 'var(--text-primary)', margin: '0 0 3px', lineHeight: 1.2}}>{t.cim}</h3>
                    <p style={{fontSize: '13px', color: 'var(--text-secondary)', margin: 0, lineHeight: 1.4, fontWeight: '600'}}>{t.rovid}</p>
                  </div>
                  <div style={{fontSize: '18px', color: t.szin, flexShrink: 0, transition: 'transform 0.3s', transform: nyitva ? 'rotate(180deg)' : 'rotate(0deg)'}}>▾</div>
                </div>

                {nyitva && (
                  <div style={{padding: '0 1.5rem 1.5rem', borderTop: '1px solid ' + t.szin + '20', animation: 'felugrikF 0.3s ease-out'}}>
                    <div style={{paddingTop: '1.25rem'}}>
                      {t.tipus === 'utmutato' && t.lepesek ? (
                        <LepesesUtmutato tartalom={t}/>
                      ) : (
                        <pre style={{fontSize: '15px', color: 'var(--text-secondary)', lineHeight: '1.85', fontFamily: 'Lora, serif', margin: 0, whiteSpace: 'pre-wrap', fontWeight: '600'}}>{t.teljes}</pre>
                      )}
                      <div style={{display: 'flex', gap: '6px', flexWrap: 'wrap', marginTop: '1.25rem', paddingTop: '1rem', borderTop: '1px solid ' + t.szin + '15'}}>
                        {t.cimkek.map(c => (
                          <span key={c} onClick={() => setKereses(c)}
                            style={{fontSize: '12px', background: t.szin + '12', color: t.szin, borderRadius: '6px', padding: '3px 10px', fontWeight: '800', cursor: 'pointer', border: '1px solid ' + t.szin + '25'}}>
                            #{c}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {szurt.length === 0 && (
          <div style={{textAlign: 'center', padding: '4rem 2rem'}}>
            <div style={{fontSize: '64px', marginBottom: '1rem'}}>🔍</div>
            <p style={{fontSize: '20px', fontWeight: '800', color: 'var(--text-muted)'}}>Nincs találat erre: "{kereses}"</p>
            <button onClick={() => { setKereses(''); setAktivKor('osszes'); setAktivKategoria('osszes'); }} className="f-btn"
              style={{padding: '12px 28px', background: 'linear-gradient(135deg, #7c3aed, #6d28d9)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '15px', fontWeight: '800', cursor: 'pointer', marginTop: '1rem'}}>
              🔄 Szűrők törlése
            </button>
          </div>
        )}

      </div>
    </div>
  );
}

export default Fogalmak;